import axios from "axios";
import React, { useEffect, useState } from "react";
import { Box, Button, Icon } from "@mui/material";
import { useHistory } from "react-router-dom";
import Loading from "components/ui/loading";
import { loadFavAlert } from "redux/reducers/top";
import { useDispatch, useSelector } from "react-redux";
import { Cookies } from "react-cookie";
import { DrawerProduct } from "components/product-of-week/drawer-product";

export default function MyReviewItems() {
  const history = useHistory();
  const dispatch = useDispatch();

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp == "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";
  const { favAlertOpen } = useSelector((state) => state.top);
  const [listData, setListData] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [drawerHigh, setDrawerHigh] = useState(false);
  const [flyer, setFlyer] = useState([]);
  const [token, setToken] = useState("");

  useEffect(() => {
    setFetching(true);
    setToken(cookies.get("X-AUTH-TOKEN"));
    loadList();
    loadFlyer();
  }, []);

  const handleDrawerHighOpen = () => {
    setDrawerHigh(true);
  };
  const handleDrawerHighClose = () => {
    setDrawerHigh(false);
  };

  const loadList = async () => {
    await axios
      .get(`/api/eh/product/buy-list`, { params: { schTp: favInfo.visibleTp } })
      .then((res) => {
        setListData(res.data.data.productList);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const loadUrl = async () => {
    await axios
      .get(`/api/sm/store/get/${storeCode}`)
      .then((res) => {
        location.href = `${res.data.data.store.ebookUrlApp}`;
      })
      .catch((error) => {});
  };

  const loadFlyer = () => {
    let localToken = cookies.get("X-AUTH-TOKEN");

    axios
      .get(`/api/sm/store/get-leaflet/${localToken ? storeCode : "2701"}`)
      .then((res) => {
        setFlyer(res.data.data);
      })
      .catch((error) => {});
  };

  const moveToRecommend = () => {
    if (token && !storeCode) dispatch(loadFavAlert(true));
    else handleDrawerHighOpen();

    // if (storeCode) {
    //   loadUrl();
    // } else {
    //   dispatch(loadFavAlert(true));
    // }
  };

  window.appBackKeyHandle = () => {
    if (favAlertOpen) {
      dispatch(loadFavAlert(false));
    } else if (drawerHigh) {
      handleDrawerHighClose();
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <Loading open={fetching} />
      <div className="myReviewItems">
        {listData.length > 0 ? (
          <ul className="my-review-list">
            {listData &&
              listData.length > 0 &&
              listData.map((item, i) => (
                <li key={i} className="my-review-item">
                  <div className="img">
                    <div className="img-wrap">
                      <img src={item.prodImgUrl} />
                    </div>
                  </div>
                  <div className="tit-wrap">
                    <div className="tit">{item.ttl}</div>
                    <div className="price">
                      {item.prc.toLocaleString()}
                      <span>원</span>
                    </div>
                    <Button
                      startIcon={
                        <Icon>
                          <img
                            src={`${
                              process.env.PUBLIC_URL
                            }/images/icon/review-red.svg`}
                          />
                        </Icon>
                      }
                      onClick={() => {
                        history.push({
                          pathname: `/my-review/detail/${item.seq}`,
                          props: {
                            seq: "",
                            prodImgUrl: item.prodImgUrl,
                            pdTtl: item.ttl,
                          },
                        });
                      }}
                    >
                      리뷰쓰기
                    </Button>
                  </div>
                </li>
              ))}
          </ul>
        ) : (
          <div className="nodata">
            <Box className="illust">
              <img src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`} />
            </Box>
            <p className="color-info">리뷰 쓰기가 가능한 상품이 없습니다</p>
          </div>
        )}

        <div className="recommend">
          <p>
            {listData && listData.length == 0 ? (
              <>
                BEST 추천상품 구매 시 리뷰 작성 가능!
                <br />
                리뷰 쓰고 100 포인트 받으세요!
              </>
            ) : (
              <>
                BEST 추천상품 더 쇼핑하고
                <br />
                리뷰 포인트까지!
              </>
            )}
          </p>
          <Button
            variant="outlined"
            color="primary"
            className="btn-rounded end-icon"
            size="small"
            endIcon={<i className="ico-go" />}
            onClick={() => {
              // moveToRecommend();
              history.push("/product-of-week");
            }}
          >
            추천상품 보기
          </Button>
          <DrawerProduct
            flyer={flyer}
            drawerHigh={drawerHigh}
            handleDrawerHighClose={handleDrawerHighClose}
          />
        </div>
      </div>
    </>
  );
}
